import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Prototyping.css'
import prototypeHero from "../../../assets/images/Prototyping.png";
import prototypePreview from "../../../assets/images/Prototyping.png";

const PrototypingPage = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Prototyping – BuddyTech Solutions </title>
        <meta name="description" content="Interactive prototypes to test usability and validate features before development." />
        <meta name="keywords" content="prototyping, UI prototype" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Prototyping – BuddyTech Solutions" />
        <meta property="og:description" content="Interactive prototypes to test usability and validate features before development." />
        <meta property="og:keywords" content="prototyping, UI prototype" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/uiux/prototyping" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Prototyping – BuddyTech Solutions" />
        <meta name="twitter:description" content="Interactive prototypes to test usability and validate features before development." />
        <meta name="twitter:keywords" content="prototyping, UI prototype" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="prototype-container">
        <header className="prototype-hero">
          <div className="prototype-hero-content">
            <h1>Interactive Prototyping</h1>
            <p>
              We bring static wireframes to life with interactive prototypes that simulate the user experience and help validate your product's flow.
            </p>
          </div>
          <img src={prototypeHero} alt="Prototyping Hero" className="prototype-hero-img" />
        </header>

        <section className="prototype-section">
          <div className="prototype-text">
            <h2>Why Prototypes Matter</h2>
            <p>
              Prototypes allow stakeholders and users to experience interactions before development begins. They help uncover usability issues early, enhance collaboration, and speed up iteration.
            </p>
            <ul>
              <li>Clickable UI Simulations</li>
              <li>User Flow Demonstration</li>
              <li>Realistic Transitions & Animations</li>
              <li>Mobile, Web & Tablet Prototypes</li>
              <li>Developer Handoff Support</li>
            </ul>
          </div>
          <img src={prototypePreview} alt="Prototype Preview" className="prototype-img" />
        </section>

        <section className="prototype-tools">
          <h2>Tools We Use</h2>
          <div className="tools-grid">
            <span>Figma</span>
            <span>Adobe XD</span>
            <span>InVision</span>
            <span>Framer</span>
            <span>ProtoPie</span>
            <span>Axure</span>
            <span>Marvel</span>
            <span>UXPin</span>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 1</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:sureshperiyasamy98@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919361367843" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919361367843">Call Us</a>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 2</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:jprakash0502@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919994694028" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919994694028">Call Us</a>
          </div>
        </section>
        <h2 className="permanent-marker-regular">specialist - 3</h2>
        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:swethadee1407@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/916379359918" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+916379359918">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default PrototypingPage;